(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('ScheduleTestEditController', ScheduleTestEditController);
    ScheduleTestEditController.$inject = ['$uibModalInstance','VirtualFairService','AdmService', '$uibModal','$scope','test', 'representative'];

    function ScheduleTestEditController($uibModalInstance,VirtualFairService,AdmService, $uibModal, $scope, test , representative) {

        var vm = this;
        vm.cancel = cancel;
        vm.getSellers = getSellers;
        vm.updateVirtualFairTest = updateVirtualFairTest;
        vm.sellerSelected = '';
        vm.test = test;
        vm.dateRangeStart = test.start_date;
        vm.dateRangeEnd = test.end_date;

        function cancel() {
            $uibModalInstance.close();
        }

        function active() {
            getSellers();
        }

        function getSellers() {
            vm.query = {};
            // vm.query['toArray'] = true;
            AdmService.getSellers(vm.query).then(function (response) {
                vm.sellers = response.data;
                vm.sellerSelected = {id: vm.sellers[test.seller.id].id, name: vm.sellers[test.seller.id].name};
            }).catch(function (err) {
            });
        }

        function updateVirtualFairTest() {

            vm.query = {};
            vm.query['id'] = vm.test.id;
            vm.query['admin_user_id'] = vm.sellerSelected.id;
            vm.query['start'] = convertToUTC(new Date(vm.dateRangeStart));
            vm.query['end'] = convertToUTC(new Date(vm.dateRangeEnd));
            VirtualFairService.updateTest(vm.query).then(function (response) {
                representative.tests[response.id] = response;
                $uibModalInstance.close();
                //$uibModalInstance.close();
            }).catch(function (err) {
            });
        }

        vm.convertToUTC = convertToUTC;
        function convertToUTC(date)
        {
            return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
        }

        /* Bindable functions
         -----------------------------------------------*/
        vm.endDateBeforeRender = endDateBeforeRender;
        vm.endDateOnSetTime = endDateOnSetTime;
        vm.startDateBeforeRender = startDateBeforeRender;
        vm.startDateOnSetTime = startDateOnSetTime;

        function startDateOnSetTime () {
            //vm.startDate = vm.dateRangeStart.format('DD/MMM/YYYY h:mm');
            $scope.$broadcast('start-date-changed');
        }

        function endDateOnSetTime () {
            //vm.startDate = vm.dateRangeEnd.format('DD/MMM/YYYY h:mm');
            $scope.$broadcast('end-date-changed');
        }

        function startDateBeforeRender ($dates) {
            if (vm.dateRangeEnd) {
                var activeDate = moment(vm.dateRangeEnd);
                $dates.filter(function (date) {
                    return date.localDateValue() >= activeDate.valueOf();
                }).forEach(function (date) {
                    date.selectable = false;
                });
            }
        }

        function endDateBeforeRender ($view, $dates) {
            if (vm.dateRangeStart) {
                var activeDate = moment(vm.dateRangeStart).subtract(1, $view).add(1, 'minute');
                console.log(activeDate.valueOf());
                $dates.filter(function (date) {
                    return date.localDateValue() <= activeDate.valueOf();
                }).forEach(function (date) {
                    date.selectable = false;
                });
            }
        }

        active();

    }

})();